export default "__VITE_ASSET__BUGJmTbb__"